import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lti/environments/environment';

export interface ReloadResponse {
	url: string;
}

@Injectable({
	providedIn: 'root'
})
export class LtiService {
	constructor (
		private http: HttpClient
	) {}

	public reload (appData): Observable<ReloadResponse> {
		return this.http.post<ReloadResponse>(`${environment.ltiBaseUrl}/reload`, {appData});
	}
}
